module.exports = __webpack_public_path__ + "img/notification-important.82b19c64.svg";